import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import { DRNText } from '@traveloka/district-ui';
import R from 'common/res/R';
import {
  PNR_STATUS_ENUM,
  PNR_STATUS_LABEL_MAPPING,
  PNR_STATUS_LIST,
} from '../../constants/pnrStatuses';

const containerStyle = {
  paddingHorizontal: R.spacing.xs,
  paddingVertical: 6,
  borderRadius: 2,
  alignSelf: 'flex-start',
};

const styles = StyleSheet.create({
  default: containerStyle,
  [PNR_STATUS_ENUM.BOOKED]: {
    ...containerStyle,
    backgroundColor: '#fca000',
  },
  [PNR_STATUS_ENUM.ISSUED]: {
    ...containerStyle,
    backgroundColor: R.color.brand,
  },
  [PNR_STATUS_ENUM.BOOKED_CANCELLED]: {
    ...containerStyle,
    backgroundColor: R.color.error,
  },
  [PNR_STATUS_ENUM.CANCELLED]: {
    ...containerStyle,
    backgroundColor: R.color.error,
  },
  [PNR_STATUS_ENUM.CANCELLED_ISSUED]: {
    ...containerStyle,
    backgroundColor: R.color.error,
  },
  [PNR_STATUS_ENUM.FAILED]: {
    ...containerStyle,
    backgroundColor: R.color.error,
  },
  text: {
    ...R.typography.weightMedium,
    marginTop: 0,
    marginBottom: 0,
    color: R.color.uiLightPrimary,
    fontSize: R.typography.fontSize.tiny,
    lineHeight: R.typography.fontSize.tiny,
  },
});

export default class BusPnrStatusComponent extends React.PureComponent {
  static propTypes = {
    status: PropTypes.oneOf(PNR_STATUS_LIST).isRequired,
  };

  render() {
    return (
      <View style={styles[this.props.status] || styles.default}>
        <DRNText style={styles.text}>
          {PNR_STATUS_LABEL_MAPPING[this.props.status] || ''}
        </DRNText>
      </View>
    );
  }
}
